import React from "react"

const NoMealsLoggedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="95"
      height="95"
      viewBox="0 0 95 95"
      fill="none"
    >
      <g clipPath="url(#clip0_40002056_160318)">
        <path
          d="M28.7019 66.0648C26.1898 64.6239 24.4923 61.9168 24.4923 58.8184C24.4923 46.0294 34.8967 35.625 47.6857 35.625H57.2435L57.6936 28.2031H3.53711L7.42707 92.3849C7.51622 93.8541 8.73315 95 10.2052 95H27.2828C25.5317 92.6727 24.4923 89.7808 24.4923 86.6504C24.4923 83.0416 26.7943 79.9606 30.0065 78.7973C28.8679 77.0512 28.2032 74.9696 28.2032 72.7344C28.2032 70.4969 28.8693 68.4132 30.0102 66.6657C29.1027 66.4613 28.599 66.2605 28.7019 66.0648Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M30.6123 22.6374C30.6145 22.6374 30.6167 22.6367 30.6189 22.6367H58.4473C59.9846 22.6367 61.2305 21.3908 61.2305 19.8535C61.2305 18.3162 59.9846 17.0703 58.4473 17.0703H35.7533L43.2556 5.56641H52.8809C54.4181 5.56641 55.6641 4.32049 55.6641 2.7832C55.6641 1.24592 54.4181 0 52.8809 0H41.748C40.8073 0 39.9303 0.474739 39.4171 1.26259L29.1077 17.0703H2.7832C1.24592 17.0703 0 18.3162 0 19.8535C0 21.3908 1.24592 22.6367 2.7832 22.6367H30.6022C30.6058 22.6367 30.6094 22.6374 30.6123 22.6374Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M30.0586 58.8145C30.0586 60.3517 31.3045 61.5977 32.8418 61.5977H92.2168C93.7541 61.5977 95 60.3517 95 58.8145C95 49.095 87.0925 41.1875 77.373 41.1875H47.6855C37.9661 41.1875 30.0586 49.095 30.0586 58.8145Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M39.3359 67.1719C36.2614 67.1719 33.7695 69.6637 33.7695 72.7383C33.7695 75.8129 36.2614 78.3047 39.3359 78.3047H85.7227C88.7972 78.3047 91.2891 75.8129 91.2891 72.7383C91.2891 69.6637 88.7972 67.1719 85.7227 67.1719H39.3359Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M92.2168 83.8672H32.8418C31.3045 83.8672 30.0586 85.1131 30.0586 86.6504C30.0586 91.2543 33.8043 95 38.4082 95H86.6504C91.2543 95 95 91.2543 95 86.6504C95 85.1131 93.7541 83.8672 92.2168 83.8672Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
      </g>
      <defs>
        <clipPath id="clip0_40002056_160318">
          <rect width="95" height="95" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NoMealsLoggedIcon
